import {createEffect} from 'effector';
import {api} from '../../api/axiosInstance.js';

export const getOrganizationDataFx = createEffect()
.use(async (id) => (await api().get(`/dashboard-organizations/${id}`)).data)

export const getOrganizationInfoGovFx = createEffect()
.use(async (gov_id) => (await api().get(`/organization/gov/${gov_id}`)).data)

export const getOrganizationInfoFullFx = createEffect()
    .use(async (id) => (await api().get(`/organization/${id}`)).data)